/** object URL 释放延迟：下载已经开始后仍保留一段时间，避免大文件流式读取被打断。 */
export const DOWNLOAD_URL_REVOKE_DELAY_MS = 10_000

/**
 * 触发浏览器下载本地 Blob。
 *
 * 直接对未挂载的 `<a>` 调用 `click()` 并在同一轮任务里 `revokeObjectURL` 会让下载在
 * Chrome/Edge 上以“无法下载 - 网络错误”结束：下载是异步开始的，URL 可能已经失效。
 * 这里统一为：挂载 anchor → click → 移除 → 延迟释放 object URL。
 */
export function downloadBlob(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob)
  downloadUrl(url, fileName)
  releaseObjectUrlLater(url)
}

/** 复用已存在的 object URL 触发下载；调用方负责该 URL 的最终释放。 */
export function downloadUrl(url: string, fileName: string): void {
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  link.rel = 'noopener'
  link.style.display = 'none'
  document.body.appendChild(link)

  try {
    link.click()
  } finally {
    link.remove()
  }
}

/** 延迟释放 object URL，确保浏览器已经接管下载。 */
export function releaseObjectUrlLater(
  url: string,
  delayMs = DOWNLOAD_URL_REVOKE_DELAY_MS,
  target: Pick<typeof globalThis, 'setTimeout'> = globalThis,
): void {
  target.setTimeout(() => {
    URL.revokeObjectURL(url)
  }, delayMs)
}
